<template>
    <div>
        <div class="panel-body">
            <div class="user-pc-builds m-l m-t">
                <div class="builds-tables">
                    <div class="table-responsive">
                        <div id="no-more-tables">
                            <template v-if="returnTickets.length && !loadingReturnTickets">
                                <div v-for="ticket in returnTickets" class="ticket-wrapper clearfix text-white">
                                    <div class="col-md-8 col-xs-5 ticket-number">
                                        <div class="col-md-3 col-xs-12 ticket-number">{{ticket.id}}</div>
                                        <div class="col-md-5 col-xs-12 ticket-number-date">
                                            {{ticket.subject}}
                                        </div>
                                        <div class="col-md-4 col-xs-12 ticket-number-date">
                                            {{ticket.created_at | relativeDate }}
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-xs-7 text-right">
                                        <a
                                            :href="'/users/tickets/show/' + ticket.id"
                                            class="btn btn-sm btn-round btn-green"
                                            to=""
                                            target="_blank">
                                            {{ticket.status}}
                                            <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                    <div class="clearfix"></div>
                                    <hr>
                                </div>
                            </template>
                            <template v-if="!returnTickets.length && !loadingReturnTickets">
                                <div class="text-center">
                                    <h4 class="text-white m-b-md">
                                        You have not created a RMA Request from LETSBLD.com yet!
                                        <br>
                                        <a href="#" @click="createTicket()">CLICK HERE</a>
                                        to Submit a RMA Request.
                                    </h4>
                                </div>
                            </template>
                            <template v-if="loadingReturnTickets">
                                <div style="text-align:center">
                                    <span class="fa fa-spin fa-spinner"></span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "return-management",
        data() {
            return {
                loadingReturnTickets: true,
                returnTickets: [],
                selectedReturnTicket: {}
            }
        },
        created() {
            this.getReturnTickets();
        },
        methods: {
            //  Gets the returnTickets of the logged in user
            getReturnTickets() {
                axios({
                    url: "/tickets?department=rma_support",
                    method: "GET"
                }).then(returnTickets => {
                    if (returnTickets.data.tickets) {
                        this.returnTickets = returnTickets.data.tickets;
                    }
                    this.loadingReturnTickets = false;
                }).catch(error => {
                    this.loadingReturnTickets = false;
                    toastr.error(error);
                })
            },
            createTicket() {
                this.$emit("createRma");
            }
        }
    }
</script>

<style scoped lang="scss">
@import '~@s/_asset-mixers.scss';

.user-field .field-value {
    font-size: 18px;
    line-height: 1;
    color: #fff;
}
td.total-price {
    background-color: $purple;
    color: #fff;
}
table td {
    font-size: 18px;
    color: #fff;
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid $purple;
}

table th {
    font-size: 14px;
    color: $purple;
}

.blue-btn {
    background-color: $purple;
    text-transform: uppercase;
    display: inline-block;
    width: 100%;
    text-align: center;
    color: #000;
    letter-spacing: 2px;
    border: none;
    border-radius: 25px;
    padding: 10px 10px;
    transition: all 0.4s ease;
    font-size: 12px;
    line-height: 20px;
    padding: 5px 0;
    width: 158px;
}

.order-wrapper {
    border-bottom: 1px solid #fff;
    padding: 10px 0;
}
</style>
